var map = {
	"./de-DE/text_back.png": "2d89",
	"./en-GB/text_back.png": "04ef",
	"./en-US/text_back.png": "dba9",
	"./es-ES/text_back.png": "c803",
	"./es-MX/text_back.png": "7c4b",
	"./fr-CA/text_back.png": "2d71",
	"./fr-FR/text_back.png": "429c",
	"./it-IT/text_back.png": "03e8",
	"./ja-JP/text_back.png": "2e34",
	"./pt-BR/text_back.png": "434a",
	"./zh-TW/text_back.png": "09fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9915";